import AppRoutes from "./router/AppRoutes";

const App = () => {
  return <AppRoutes />;
};

export default App;
